"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var DayButtonStyle = {
    border: '1px solid #CCC',
    borderRadius: '2px',
    display: 'inline-block',
    textAlign: 'center',
    width: '30px',
    cursor: 'default',
    marginRight: '3px',
    marginTop: '2px',
    marginBottom: '1px',
    flex: '0 1 30px',
    minWidth: 'unset',
    padding: '0'
};
/** TODO: This should ideally come from shared-widgets **/
var MonthMultiDayPicker = /** @class */ (function (_super) {
    __extends(MonthMultiDayPicker, _super);
    function MonthMultiDayPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderMonthMultiDayMapperWidget = function (monthDay) {
            return React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, key: monthDay.id, getContent: function () { return React.createElement(React.Fragment, null, monthDay.caption); }, handleClick: function () { return _this.DaysToggleInternal(monthDay.id); }, selected: _this.isButtonSelected(monthDay.id), style: DayButtonStyle, testId: "monthDay" + monthDay.id });
        };
        return _this;
    }
    MonthMultiDayPicker.prototype.isButtonSelected = function (dayId) {
        return this.props.selectedDayIds && this.props.selectedDayIds.indexOf(dayId) >= 0;
    };
    MonthMultiDayPicker.prototype.DaysToggleInternal = function (dayId) {
        var selectedIds = this.props.selectedDayIds;
        var alreadySelectedIndex = selectedIds ? selectedIds.indexOf(dayId) : -1;
        var resultSelection;
        if (alreadySelectedIndex >= 0) {
            if (selectedIds.length > 1) {
                resultSelection = selectedIds.slice();
                resultSelection.splice(alreadySelectedIndex, 1);
            }
            else {
                resultSelection = selectedIds;
            }
        }
        else {
            resultSelection = selectedIds.concat([dayId]);
        }
        this.props.onSelectionChanged(resultSelection);
    };
    MonthMultiDayPicker.prototype.render = function () {
        return (React.createElement("div", { id: exports.DomId, "data-tb-test-id": this.props.testId, style: this.props.style }, this.props.monthDays.map(this.renderMonthMultiDayMapperWidget)));
    };
    return MonthMultiDayPicker;
}(React.Component));
exports.MonthMultiDayPicker = MonthMultiDayPicker;
exports.DomId = 'month-multi-day-picker';
//# sourceMappingURL=MonthMultiDayPicker.js.map